import React from 'react';

export default function MultiplierIntro() {
  return (
    <section
      id="multiplier-intro"
      className="mx-auto max-w-7xl scroll-mt-28 px-6 pb-24 pt-24 text-white md:pb-28"
    >
      <div className="overflow-hidden rounded-[34px] border border-[hsl(var(--landing-accent-ring)/0.35)] bg-gradient-to-br from-[hsl(var(--landing-accent)/0.25)] via-[hsl(var(--landing-accent-ring)/0.12)] to-slate-900 p-10 text-white shadow-[0_30px_80px_hsl(var(--landing-accent)/0.15)] md:p-14">
        <div className="grid gap-10 md:grid-cols-[1.1fr_0.9fr] md:items-center">
          <div className="max-w-3xl">
            <p className="text-sm uppercase tracking-[0.22em] text-[hsl(var(--landing-accent-foreground))]">Why it works</p>
            <h2 className="mt-4 text-4xl font-semibold tracking-tight text-white md:text-5xl">
              Keep your store as your home base. Let your products travel through trust.
            </h2>
            <p className="mt-5 text-lg leading-8 text-white/80">
              Your store remains the place that holds your identity, your pricing, your fulfillment,
              and your customer relationship. Katalag and Kloutforce simply change how discovery
              happens around it. Your products move through trusted people who already have
              attention and trust, so offers become easier to understand, easier to share, and
              easier to act on. Instead of spending upfront hoping something works, you share value
              when it actually does.
            </p>
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            {[
              'A trusted introduction lowers suspicion before the offer is even seen',
              'A clear, exclusive deal makes the decision easier to take and to share',
              'A meaningful commission gives sellers a real reason to keep showing up',
              'Ongoing presence through trusted catalogs keeps the offer alive over time',
            ].map((item) => (
              <div
                key={item}
                className="rounded-[24px] border border-white/10 bg-slate-950/40 p-5 text-sm leading-7 text-white/80 backdrop-blur"
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
